import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { VFFieldProps } from '../types';
import { FormItem } from './FormItem';
import classNames from 'classnames';
import { ImageGalleryInput } from '../../image-gallery/ImageGalleryInput';
export type ImageProps = Omit<
  VFFieldProps<React.ComponentProps<typeof ImageGalleryInput>>,
  'value' | 'label'
>;

export const ImageGallery = React.forwardRef<HTMLInputElement, ImageProps>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      required,
      disabled,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={undefined}
        required={required}
        disabled={disabled}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name}>
          {({ input: { value, onChange }, meta }: FieldRenderProps<any>) => {
            return (
              <ImageGalleryInput
                {...other}
                disabled={disabled || meta.submitting}
                className={classNames(inputClassName)}
                onChange={(newValue) => {
                  onChange({ target: { name, value: newValue } });
                }}
                value={value}
                // @ts-ignore
                ref={ref}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
